import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { PickupModalityOption, PickupOption, Restaurant } from '@/models';

@Component({
  name: 'CmgPickupOptionsModal',
})
export default class CmgPickupOptionsModal extends Vue {
  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.pickupOptionsModal.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.pickupOptionsModal.args;
  }

  get selectedRestaurant(): Restaurant | undefined {
    return this.args?.restaurant;
  }

  get isDiningRoomClosed(): boolean {
    return !this.selectedRestaurant?.diningRoomOpen;
  }

  get dineInClosedText(): string {
    return this.$appStore.state.cms.pickupModality?.dineInNotOpen ?? 'No dine-in available.';
  }

  get pickupOptions(): PickupModalityOption[] | undefined {
    return this.$appStore.state.cms.pickupModality?.pickupOptions.filter(option => {
      if (option.title == PickupOption.Pickup && this.selectedRestaurant?.pickupInsideEnabled ||
        option.title == PickupOption.Chipotlane && this.selectedRestaurant?.chipotlanePickupEnabled ||
        option.title == PickupOption.WalkUp && this.selectedRestaurant?.walkupWindowEnabled ||
        option.title == PickupOption.DigitalKitchen && this.selectedRestaurant?.digitalKitchen ) {
        return true;
      }
    });
  }

  mounted() {
    const pickupOptionsModalElement = document.getElementsByClassName('cmg-pickup-options-modal')[0] as HTMLElement;
      pickupOptionsModalElement.addEventListener('keyup', (event) => {
        if(event.key == 'Escape') {
          event.stopImmediatePropagation();
          this.onClose();    
        }
      });
  }

  onClickOk(): void {
    this.onClose();
  }

  onClose() {
    this.$services.ui.setModalVisibility('pickupOptionsModal', false);
    this.$services.ui.focusBack();
  }
}
